module.exports = __webpack_public_path__ + "static/media/online-shopping.ba7ec615.svg";